<template>
  <v-row style="background-color: #F4F6F8;" class="mx-0">
    <v-container class="footer-info" style="background-color: #F4F6F8;">
      <v-row class="flex-column flex-md-row">
        <v-col
          class="pb-9 pb-md-3 d-flex align-center justify-center justify-md-start"
        >
          <router-link :to="`${$route.params.lang === 'en' ? '/en' : '/'}`">
            <img class="pr-8" src="@/assets/edu-logo.svg" />
          </router-link>
          <a href="https://sumit.sum.ba" target="_blank">
            <img src="@/assets/sumit-logo.svg" />
          </a>
        </v-col>
        <v-col
          class="pb-9 pb-md-3 d-flex justify-center align-center text-body-2"
          >{{ $t('footer_rights') }}
        </v-col>
        <v-col class="icons d-flex justify-center justify-md-end align-center">
          <a href="https://twitter.com/sve_mostar" target="_blank">
            <v-avatar color="#BDC3CA" size="20">
              <v-icon class="icon" color="white" size="12">mdi-twitter </v-icon>
            </v-avatar>
          </a>
          <a
            href="https://www.youtube.com/channel/UCgqbhSxPBuVGfAEEnxEk2cQ"
            target="_blank"
          >
            <v-avatar color="#BDC3CA" size="20">
              <v-icon class="icon" color="white" size="12">mdi-youtube </v-icon>
            </v-avatar>
          </a>
          <a
            href="https://www.instagram.com/sveucilisteumostaru/?hl=hr"
            target="_blank"
          >
            <v-avatar color="#BDC3CA" size="20">
              <v-icon class="icon" color="white" size="12"
                >mdi-instagram
              </v-icon>
            </v-avatar>
          </a>
          <a href="https://www.facebook.com/skole.sum.ba/" target="_blank">
            <v-icon class="fb-icon" color="#BDC3CA" size="22"
              >mdi-facebook
            </v-icon>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>
export default {
  data: () => ({})
};
</script>

<style>
.icons a {
  text-decoration: none;
}
</style>
